// Wishlist AGL basata sulle API JS di Swym (window._swat).
// Espone window.AGLWishlist e sincronizza tutti i [data-wishlist-button] e [data-wishlist-count].

(function () {
  if (window.AGLWishlist) return;

  const strings = window.AGLWishlistStrings || {};
  const state = { swat: null, lid: null, items: [] };
  let resolveReady;
  const ready = new Promise((resolve) => (resolveReady = resolve));

  // ── Swym helpers (callback → Promise) ─────────────────────────────────
  const swym = {
    fetchLists: () =>
      new Promise((resolve, reject) => state.swat.fetchLists({ callbackFn: resolve, errorFn: reject })),
    createList: () =>
      new Promise((resolve, reject) => state.swat.createList({ lname: 'Wishlist' }, resolve, reject)),
    addToList: (product) =>
      new Promise((resolve, reject) => state.swat.addToList(state.lid, product, resolve, reject)),
    deleteFromList: (product) =>
      new Promise((resolve, reject) => state.swat.deleteFromList(state.lid, product, resolve, reject)),
  };

  async function loadList() {
    const lists = await swym.fetchLists();
    const list = Array.isArray(lists) ? lists[0] : null;
    state.lid = list ? list.lid : null;
    state.items = list && Array.isArray(list.listcontents) ? list.listcontents : [];
    render();
  }

  async function ensureList() {
    if (state.lid) return;
    const list = await swym.createList();
    state.lid = list.lid;
  }

  async function withSwym() {
    await ready;
    if (!state.swat) throw new Error('Swym SDK non disponibile');
  }

  // ── API pubblica ──────────────────────────────────────────────────────
  function getItems() {
    return state.items.slice();
  }

  function isWishlisted(empi) {
    return state.items.some((item) => Number(item.empi) === Number(empi));
  }

  async function add({ epi, empi, du }) {
    await withSwym();
    await ensureList();
    const product = { epi: Number(epi), empi: Number(empi), du };
    await swym.addToList(product);
    state.items.push(product);
    render();
    toast(strings.added, { label: strings.view, href: strings.pageUrl });
  }

  async function remove(empi) {
    await withSwym();
    const matches = state.items.filter((item) => Number(item.empi) === Number(empi));
    await Promise.all(
      matches.map((item) => swym.deleteFromList({ epi: item.epi, empi: item.empi, du: item.du }))
    );
    state.items = state.items.filter((item) => !matches.includes(item));
    render();
    toast(strings.removed);
  }

  // Swym non permette di cambiare la variante di un item: aggiungiamo la nuova e togliamo la vecchia
  async function changeVariant(item, newEpi) {
    await withSwym();
    const next = { epi: Number(newEpi), empi: Number(item.empi), du: item.du };
    await swym.addToList(next);
    await swym.deleteFromList({ epi: item.epi, empi: item.empi, du: item.du });
    state.items = state.items
      .filter((current) => Number(current.epi) !== next.epi)
      .map((current) => (Number(current.epi) === Number(item.epi) ? next : current));
    render();
    toast(strings.sizeUpdated);
    return next;
  }

  // ── UI ────────────────────────────────────────────────────────────────
  function render() {
    syncUI();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: getItems() } }));
  }

  function syncUI() {
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const active = isWishlisted(button.dataset.productId);
      button.setAttribute('aria-pressed', active);
      button.setAttribute('aria-label', active ? strings.removeLabel : strings.addLabel);
      button.querySelector('[data-wishlist-icon-empty]')?.classList.toggle('hidden', active);
      button.querySelector('[data-wishlist-icon-full]')?.classList.toggle('hidden', !active);
    });

    const count = new Set(state.items.map((item) => Number(item.empi))).size;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function toast(message, action) {
    if (!message) return;

    let container = document.getElementById('WishlistToasts');
    if (!container) {
      container = document.createElement('div');
      container.id = 'WishlistToasts';
      container.className =
        'pointer-events-none fixed bottom-4 left-4 right-4 z-[70] flex flex-col items-end gap-2 md:left-auto';
      container.setAttribute('aria-live', 'polite');
      document.body.appendChild(container);
    }

    const el = document.createElement('div');
    el.className =
      'pointer-events-auto flex w-full items-center justify-between gap-6 bg-black px-5 py-4 text-[13px] font-light text-white opacity-0 translate-y-3 transition duration-300 ease-out md:w-[360px]';
    el.setAttribute('role', 'status');

    const text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);

    if (action && action.href && action.label) {
      const link = document.createElement('a');
      link.href = action.href;
      link.textContent = action.label;
      link.className = 'shrink-0 text-[12px] uppercase underline';
      el.appendChild(link);
    }

    container.appendChild(el);
    requestAnimationFrame(() => el.classList.remove('opacity-0', 'translate-y-3'));

    setTimeout(() => {
      el.classList.add('opacity-0', 'translate-y-3');
      el.addEventListener('transitionend', () => el.remove(), { once: true });
    }, 3500);
  }

  // ── Click sui cuori ───────────────────────────────────────────────────
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    try {
      const { productId, variantId, productUrl } = button.dataset;
      if (isWishlisted(productId)) {
        await remove(productId);
      } else {
        await add({ epi: variantId, empi: productId, du: productUrl });
      }
    } catch (error) {
      console.error(error);
      toast(strings.error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  // Card caricate dinamicamente (filtri, carousel, recently viewed…)
  const hasWishlistButton = (node) =>
    node.nodeType === 1 && (node.matches('[data-wishlist-button]') || node.querySelector('[data-wishlist-button]'));
  new MutationObserver((mutations) => {
    if (mutations.some((m) => [...m.addedNodes].some(hasWishlistButton))) syncUI();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ── Init Swym ─────────────────────────────────────────────────────────
  // Se l'SDK non arriva (app disattivata, adblock) non lasciamo i click in attesa per sempre
  setTimeout(resolveReady, 10000);

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    state.swat = swat;
    loadList()
      .catch((error) => console.error('Wishlist: errore caricamento lista', error))
      .finally(resolveReady);

    // Modifiche fatte da altre UI Swym
    const refresh = () => loadList().catch(console.error);
    swat.evtLayer?.addEventListener(swat.JSEvents.addedToWishlist, refresh);
    swat.evtLayer?.addEventListener(swat.JSEvents.removedFromWishlist, refresh);
  });

  window.AGLWishlist = { ready, getItems, isWishlisted, add, remove, changeVariant, toast };
})();
